module.exports = __webpack_public_path__ + "img/illustration-mailbox-empty-state@3x.37e84c5f.png";